import { DesignTokens, GivelifyButton } from '@givelify/ui';
import { styled } from '@mui/material';

export const Card = styled('div')(({ theme }) => ({
    display: 'flex',
    padding: '60px',
    alignItems: 'center',
    gap: '50px',
    borderRadius: '40px',
    backgroundColor: '#FAF9FC',
    maxWidth: 770,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        padding: '24px 16px',
    },
}));

export const Left = styled('div')(() => ({
    display: 'flex',
    maxWidth: 350,
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: 'white',
    borderRadius: 30,
    overflow: 'hidden',
}));

export const Right = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'start',
    maxWidth: 350,
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}));

export const PastorImg = styled('img')(() => ({
    border: '5px solid white',
    borderRadius: '50%',
    width: 80,
    height: 80,
    marginTop: '-40px',
}));

export const ButtonWrapper = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr 1fr',
    },
}));

export const BannerImg = styled('img')(() => ({
    maxWidth: '100%',
    width: '100%',
    height: 'auto',
}));

export const InfoContainer = styled('div')(() => ({
    display: 'flex',
    padding: '20px 24px 32px 24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    textAlign: 'start',

    '& .contact-section': {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        justifyItems: 'start',
        alignItems: 'center',
        columnGap: '16px',
        rowGap: '20px',
        marginTop: 20,
    },

    '& .address': {
        textAlign: 'start',
    },
}));

export const Divider = styled('div')(({ theme }) => ({
    height: 1,
    backgroundColor: '#C2C0CD',
    width: '100%',
    marginTop: 50,
    marginBottom: 50,

    [theme.breakpoints.down('sm')]: {
        marginTop: 20,
        marginBottom: 20,
    },
}));

export const StyledButton = styled(GivelifyButton)(() => ({
    borderColor: DesignTokens.color.globalGenerosityOrange400,
    color: DesignTokens.color.globalGenerosityOrange400,
    '&:hover': {
        borderColor: 'rgb(248, 85, 32)',
        backgroundColor: 'rgba(248, 85, 32, 0.04)',
        color: DesignTokens.color.globalGenerosityOrange400,
    },
}));
